module.exports = __webpack_public_path__ + "img/5.e76b2a51.png";